// extracted by mini-css-extract-plugin
export var eraseButton = "survey-module--erase-button--9d688";
export var form = "survey-module--form--ea8ed";
export var globalErrors = "survey-module--global-errors--076ed";
export var preview = "survey-module--preview--db8dc";
export var stepsContainer = "survey-module--steps-container--72124";
export var submitContainer = "survey-module--submit-container--676d8";
export var successBox = "survey-module--success-box--97c3a";
export var survey = "survey-module--survey--032f1";